<template>
  <div class="py-3">
    <v-card flat class="whiteSection">
      <v-card-text class="py-0 darkerCardText">
        <v-data-table
          :headers="headers[0]"
          :items="powers"
          hide-default-footer
          outlined
          dense
          :hide-default-header="isMobile"
        >
          <template v-slot:[`item.baseCurve`]="{ item }">
            <div class="d-flex flex-row pt-2 pt-sm-1 align-start">
              <div v-if="isMobile" class="mobileTH">BC</div>
              <div v-html="item.baseCurve"></div>
            </div>
          </template>
          <template v-slot:[`item.diameter`]="{ item }">
            <div class="d-flex flex-row pt-2 pt-sm-1 align-start">
              <div v-if="isMobile" class="mobileTH">DIAM</div>
              <div v-html="item.diameter"></div>
            </div>
          </template>
          <template v-slot:[`item.sphere`]="{ item }">
            <div class="d-flex flex-row pt-2 pt-sm-1 align-start">
              <div v-if="isMobile" class="mobileTH">SPH</div>
              <div v-html="diopterFormatter(item.sphere)"></div>
            </div>
          </template>
          <template v-slot:[`item.cylinder`]="{ item }">
            <div class="d-flex flex-row pt-2 pt-sm-1 align-start">
              <div v-if="isMobile" class="mobileTH">CYL</div>
              <div v-html="diopterFormatter(item.cylinder)"></div>
            </div>
          </template>
          <template v-slot:[`item.axis`]="{ item }">
            <div class="d-flex flex-row pt-2 pt-sm-1 align-start">
              <div v-if="isMobile" class="mobileTH">AXIS</div>
              <div v-html="diopterFormatter(item.axis)"></div>
            </div>
          </template>
          <template v-slot:[`item.addPwr`]="{ item }">
            <div class="d-flex flex-row pt-2 pt-sm-1 align-start">
              <div v-if="isMobile" class="mobileTH">ADD</div>
              <div v-html="diopterFormatter(item.addPwr)"></div>
            </div>
          </template>
          <template v-slot:[`item.vault`]="{ item }">
            <!-- <div class="pt-sm-1" v-html="listFormatter(item.vault)"></div> -->
            <div class="d-flex flex-row pt-2 pt-sm-1 align-start">
              <div v-if="isMobile" class="mobileTH">VAULT</div>
              <div v-html="diopterFormatter(item.vault)"></div>
            </div>
          </template>
          <template v-slot:[`item.colors_enh`]="{ item }">
            <div class="d-flex flex-row pt-2 pt-sm-1 align-start">
              <div v-if="isMobile" class="mobileTH">COLOR<br />(enh)</div>
              <div v-html="item.colors_enh"></div>
            </div>
          </template>
          <template v-slot:[`item.colors_opq`]="{ item }">
            <div class="d-flex flex-row pt-2 pt-sm-1 align-start">
              <div v-if="isMobile" class="mobileTH">COLOR<br />(opq)</div>
              <div v-html="item.colors_opq"></div>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <!-- <v-divider class="mb-4 mt-2" v-if="headers[1].length > 0"></v-divider> -->
    <div flat class="ma-4 grayText" v-if="headers[1] && headers[1].length > 0">
      <v-divider class="my-2"></v-divider>
      <div class="d-flex flex-row flex-wrap py-0">
        <div
          class="d-flex flex-row px-4 py-1 align-center"
          v-for="(row, i) in headers[1]"
          :key="i"
        >
          <div class="mr-2 paramLabel darkerCardText">{{ row.text }}:</div>
          <div class="body-2">
            {{ diopterFormatter(firstPowerRow[row.value]) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Name from "../dir/file";
// import KeyValue from "./KeyValue";

export default {
  name: "SoftPowerGrid",
  // components: {KeyValue},
  props: {
    powers: {
      type: Array,
      default: function () {
        return [
          { id: "", lensID: "", baseCurve: "", diameter: "", sphere: "" },
        ];
      },
    },
    additionalFields: null,
  },
  data: function () {
    return {
      fields: [
        "baseCurve",
        "vault",
        "diameter",
        "sphere",
        "cylinder",
        "axis",
        "addPwr",
        "addModifier",
        "colors_enh",
        "colors_opq",
      ],
      fieldLabels: {
        baseCurve: "BC",
        vault: "Vault",
        diameter: "Diam",
        sphere: "Sphere",
        cylinder: "Cyl",
        axis: "Axis",
        addPwr: "Add",
        addModifier: "Add Modifier",
        colors_enh: "Enhancer Colors",
        colors_opq: "Opaque Colors",
      },
    };
  },
  methods: {
    listFormatter: function (val) {
      val = val.replaceAll(/,(?=[^\s])/g, ", "); // add spaces after commas
      // val = val.replaceAll(/([ ]){2,10})/g, " ");
      return val;
    },
    diopterFormatter: function (val) {
      val = val.replaceAll(/,\s0 to/g, "<br>plano to"); // change zeros to planos
      val = val.replaceAll(/^0 to/g, "plano to"); // change zeros to planos
      val = val.replaceAll(/[+-]?[^[1-9].]0[.0]?\s?,/g, "plano<br>"); // for "..., 0, ...""
      val = val.replaceAll("steps,", "steps<br>"); // newline for each section
      val = val.replaceAll(/,(?=[^\s])/g, ", "); // add spaces after commas
      val = val.replaceAll(/to 0.00/g, "to plano"); // change zeros to planos
      val = val.replaceAll(/to 0 in/g, "to plano in"); // change zeros to planos
      val = val.replaceAll(/([+-]\d) /g, "$1.00 "); // change diopter nums to have 2 decimal places
      val = val.replaceAll(/([+-]\d) /g, "$100 "); // change diopter nums to have 2 decimal places
      val = val.replaceAll(/([+-]\d.\d) /g, "$10 "); // change diopter nums to have 2 decimal places
      return val;
    },
    axisFormatter: function (val) {
      val = val.replaceAll(/(\d),(\d)/g, "$1, $2");
      val = val.replaceAll(/(\d)(?!\d)/g, "$1&deg;");
      return val;
    },
  },
  computed: {
    allFields: function () {
      let fields = [...this.fields];
      if (this.additionalFields) {
        this.additionalFields.forEach((row) => {
          fields.push(row.key);
        });
      }
      return fields;
    },
    allFieldLabels: function () {
      let fieldLabels = this.fieldLabels;
      if (this.additionalFields) {
        this.additionalFields.forEach((row) => {
          fieldLabels[row.key] = row.label;
        });
      }
      return fieldLabels;
    },
    headerClass: function () {
      return this.$vuetify.breakpoint.smAndUp
        ? "text-h6 darkerCardText"
        : "font-weight-bold darkerCardText";
    },
    headers: function () {
      let allHeaders = [];
      let sameHeaders = [];
      let diffHeaders = [];
      let headers = [];

      // headers will be an array, where [0] will always be a table w/ sph/cyl/axis
      // if the table is small it will contain other params. If big and some params are the same for each row (eg BC is always 8.4 & 8.8) some params (bc,diam,add, colors) can be separated out and put in index [1]
      for (let field of this.allFields) {
        let headerRow = {
          text: this.allFieldLabels[field],
          value: field,
          sortable: false,
          class: this.headerClass,
        };
        let firstVal = this.powers[0][field];
        let populated = firstVal && firstVal.trim() != "";
        if (!populated) continue;
        let allSame = this.allValuesTheSame.includes(field);
        if (allSame) {
          sameHeaders.push(headerRow);
        } else {
          diffHeaders.push(headerRow);
        }
        if (populated) allHeaders.push(headerRow); // && !skip
      }
      headers[0] = allHeaders.length > 4 ? diffHeaders : allHeaders;
      headers[1] = allHeaders.length > 4 ? sameHeaders : [];
      // console.log(rtn);
      return headers;
    },
    allValuesTheSame: function () {
      let sameFields = [];
      for (let field of ["baseCurve", "diameter", "addPwr", "addModifier"]) {
        let isSame = true;
        let firstVal = this.powers[0][field];
        for (let row of this.powers) {
          // should probably start at index 1
          //console.log("val: " + row[field.value]);
          isSame = isSame && row[field] == firstVal; // should probably continue if false
        }
        if (isSame && firstVal != "") sameFields.push(field);
      }
      return sameFields;
    },
    firstPowerRow: function () {
      // console.log("FPR");
      // console.log([this.powers[0]]);
      return this.powers[0];
    },
    isMobile: function () {
      return !this.$vuetify.breakpoint.smAndUp;
    },
  },
};
</script>

<style scoped>
.paramLabel {
  font-weight: bold;
  /* color: #383838; */
}

.v-data-table >>> tr:hover {
  background: transparent !important;
}
/* th {
  color: rgba(0, 0, 0, 0.8);
} */
.v-data-table >>> td.v-data-table__mobile-row {
  align-items: start;
  text-align: left !important;
}

.v-data-table >>> .v-data-table__mobile-row__cell {
  text-align: left !important;
}
.v-data-table >>> td.text-start {
  vertical-align: top;
}
.mobileTH {
  font-weight: bold;
  padding-right: 2em;
  min-width: 70px;
  white-space: nowrap;
  text-align: right;
}
</style>
